interface QnaCategoryRow {
  code: string;
  name: string;
}

/**
 * 문의유형 이름(쿼리)으로 고정할 QC 공통코드 행을 찾는다.
 *
 * - name 을 포함하는 유형(예: "설레임" → "설레임런")이 대상. 다중 매칭 시 정확히 일치하는 유형 우선(결정적), 없으면 첫 매칭.
 * - NFT 는 옵션에서 제외되는 유형이라 매칭 대상에서도 제외(일관성).
 * - 매칭 없음·name 비어 있음·rows 미로딩 → null (호출부는 일반 선택으로 fallback).
 */
export function resolveLockedQnaCategory<T extends QnaCategoryRow>(
  rows: T[] | undefined,
  name: string | null | undefined,
): T | null {
  if (!name || !rows) return null;
  const matches = rows.filter((row) => row.name !== 'NFT' && row.name.includes(name));
  return matches.find((row) => row.name === name) ?? matches[0] ?? null;
}
